
<mat-card *ngIf="loading">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<div fxLayout="row">

  <!-- Account Info -->
  <mat-card class="sticky-header p-y-0" fxFlex="40" fxFlex.lt-lg="100"  *ngIf="!loading">
    <br />
    <mat-card-content >
      <mat-card-title>Account Information</mat-card-title>
      <div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 2em">
        <div fxLayout="row">
          <span fxFlex="30" fxFlex.lt-md="40"><strong>Account Name: </strong></span>
          <div fxLayout="column">
            <span>
              {{username}}
            </span>
          </div>
        </div>
        <div fxLayout="row">
          <span fxFlex="30" fxFlex.lt-md="40"><strong>Email Address: </strong></span>
          <div fxLayout="column">
            <span>
              {{email}}
            </span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- Roles -->
<div fxLayout="row">
  <mat-card class="sticky-header p-y-0" fxFlex="40" fxFlex.lt-lg="100"  *ngIf="!loading && roles != null && roles.length > 0">
    <mat-card-content >
      <br />
      <mat-card-title>Roles</mat-card-title>
      <div fxLayout="column" fxLayoutGap="8px" style="padding-bottom: 1em">
        <div fxLayout="row">
          <ul>
            <li  *ngFor="let role of roles">{{role}}</li>
          </ul>
        </div>
      </div>
    </mat-card-content>
  </mat-card>  
</div>
